import styled from 'styled-components';

export const Banner = styled.div`
  background: ${props => props.theme.colors.background.primaryInverse};
`;

export const TextWrapper = styled.div`
  padding: 16px 0;
`;

export const ButtonWrapper = styled.div`
  padding: 16px 8px 0 0;
`;
